import React, { useState } from "react";
import "./LocationByCityList.scss";

import Flag from "../../../../../components/Flag/Flag";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

function LocationByCityList(props) {
  const { data, height } = props;
  const [showMore, setShowMore] = useState(false);

  const onShowcase = Boolean(height);
  const FOLD_COUNT = 10;

  const getData = () => {
    switch (height) {
      case 3:
        return data?.slice(0, 4);

      default:
        return data;
    }
  };

  const getDisplayData = () => {
    const baseData = getData();

    if (onShowcase) return baseData;

    if (!baseData || baseData.length <= FOLD_COUNT) {
      return baseData;
    }

    return showMore ? baseData : baseData.slice(0, FOLD_COUNT);
  };

  const shouldShowToggle = () => {
    if (onShowcase) return false;
    const baseData = getData();
    return baseData && baseData.length > FOLD_COUNT;
  };

  const toggleExpanded = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="location-list">
      {getDisplayData()?.map((item, index) => (
        <div className="location-list__item" key={index}>
          <div className="location-list__label">
            <Flag countryCode={item.countryCode} />
            {item.name}
          </div>
          <div className="location-list__value">{item.percent}%</div>
        </div>
      ))}
      {shouldShowToggle() && (
        <div className="location-list__toggle" onClick={toggleExpanded}>
          {showMore ? (
            <IDHFormattedMessage id="ws_show_less" defaultMessage="Show less" />
          ) : (
            <IDHFormattedMessage id="ws_show_more" defaultMessage="Show more" />
          )}
        </div>
      )}
    </div>
  );
}

export { LocationByCityList };
